/* eslint-disable react-refresh/only-export-components */
import { CampusRoleAssignees } from '@/components/common/output/campus';
import type { Column } from '@/components/common/table';
import type { Campus, CampusRoleKey } from '@/shared/types/campus';
import { getOrgRoleLabel } from '@/store/org/types';
import {
  Button,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownTrigger,
} from '@heroui/react';
import { Icon } from '@iconify/react/dist/iconify.js';

export function makeColumns(
  onAction: (item: Campus, key: ActionKey) => void,
): CampusColumn[] {
  return [
    {
      key: 'name',
      label: 'Name',
      display: CampusName,
    },
    {
      key: 'oversight',
      label: getOrgRoleLabel('campus', 'oversight', true),
      display: ({ item, column }: { item: Campus; column: Column<Campus> }) => (
        <CampusRoleDisplay item={item} column={column} role='oversight' />
      ),
    },
    {
      key: 'director',
      label: getOrgRoleLabel('campus', 'director', true),
      display: ({ item, column }: { item: Campus; column: Column<Campus> }) => (
        <CampusRoleDisplay item={item} column={column} role='director' />
      ),
    },
    {
      key: 'actions',
      label: '',
      display: ({ item, column }: { item: Campus; column: Column<Campus> }) => (
        <CampusActions item={item} column={column} onAction={onAction} />
      ),
    },
  ];
}

export type ColumnKey = 'name' | 'oversight' | 'director' | 'actions';
export type ActionKey = 'edit' | 'archive';

export interface CampusColumn extends Column<Campus> {
  key: ColumnKey;
}

function CampusName({ item }: { item: Campus; column: Column<Campus> }) {
  return <div>{item.data.name}</div>;
}

function CampusRoleDisplay({
  item,
  role,
}: {
  item: Campus;
  role: CampusRoleKey;
  column: Column<Campus>;
}) {
  return <CampusRoleAssignees item={item} role={role} />;
}

function CampusActions({
  item,
  onAction,
}: {
  item: Campus;
  column: Column<Campus>;
  onAction: (item: Campus, key: ActionKey) => void;
}) {
  return (
    <Dropdown>
      <DropdownTrigger>
        <Button isIconOnly variant='light'>
          <Icon
            icon='mdi:dots-vertical'
            width={22}
            height={22}
            className='text-gray-600'
          />
        </Button>
      </DropdownTrigger>
      <DropdownMenu>
        <DropdownItem key='edit' onPress={() => onAction(item, 'edit')}>
          Edit
        </DropdownItem>
        <DropdownItem key='archive' onPress={() => onAction(item, 'archive')}>
          Archive
        </DropdownItem>
      </DropdownMenu>
    </Dropdown>
  );
}
